import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "18"}
    height={props.height || "18"}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75012 9.56247V10.125H11.2501V9.56247C11.2501 7.39156 13.0162 5.62499 15.1876 5.62499C15.3244 5.62499 15.4616 5.6377 15.5986 5.65177C15.1051 3.70257 13.3505 2.25 11.2501 2.25H6.75012C4.64974 2.25 2.89515 3.70261 2.40161 5.65177C2.53868 5.6377 2.67585 5.62499 2.81264 5.62499C4.98407 5.62499 6.75012 7.39156 6.75012 9.56247Z"
      fill="#556987"
    />
    <path
      d="M17.8868 8.75675C17.6284 7.83651 16.8691 7.08999 15.9441 6.84871C14.0648 6.35836 12.375 7.76304 12.375 9.56254V11.25H5.625V9.5625C5.625 7.763 3.93517 6.35836 2.05581 6.84868C1.13091 7.08995 0.371539 7.83648 0.113232 8.75671C-0.155857 9.71533 0.0742954 10.6164 0.595889 11.2807C0.9217 11.6957 1.125 12.1918 1.125 12.7194V14.625H3.37498V15.75H5.62497V14.625H12.375V15.75H14.6249V14.625H16.8749V12.7194C16.8749 12.1918 17.0782 11.6957 17.404 11.2807C17.9257 10.6164 18.1558 9.71536 17.8868 8.75675ZM2.81246 10.125C2.50183 10.125 2.24998 9.87317 2.24998 9.56254C2.24998 9.25183 2.50183 9.00005 2.81246 9.00005C3.1231 9.00005 3.37495 9.25183 3.37495 9.56254C3.37495 9.87314 3.1231 10.125 2.81246 10.125ZM15.1875 10.125C14.8768 10.125 14.625 9.87317 14.625 9.56254C14.625 9.25183 14.8768 9.00005 15.1875 9.00005C15.4981 9.00005 15.7499 9.25183 15.7499 9.56254C15.7499 9.87314 15.4981 10.125 15.1875 10.125Z"
      fill="#556987"
    />
  </svg>
);

export default SvgComponent;
